<template>
  <div class="content">
    <md-dialog :md-active.sync="showDialog" style="margin-left: 160px">
      <md-dialog-title>{{ $t("add_info.add_img.add_img") }}</md-dialog-title>
      <div style="padding: 20px">
        <md-field>
          <label>Select images</label>
          <md-file
            v-model="selectedImages"
            ref="file"
            @md-change="select_files"
            accept="image/*"
            :placeholder="$t('add_info.add_img.place_holder')"
            multiple
          />
        </md-field>
      </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false"
          >{{ $t("add_info.add_img.close") }}</md-button
        >
        <md-button class="md-primary" @click="save_images" :disabled="!this.files">{{ $t("add_info.add_img.save") }}</md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <div class="md-layout">
          <div class="md-card md-theme-default">
            <div class="md-card-header">
              <h4 class="title">{{ $t("add_info.location") }}</h4>
            </div>
            <div
              class="md-content"
              style="padding: 20px"
              v-if="selectedUploadLoading"
            >
              <md-progress-spinner
                md-mode="indeterminate"
              ></md-progress-spinner>
            </div>
            <div
              class="md-card-content"
              style="
                width: 100%;
                padding-top: 15px;
                padding-left: 0;
                padding-bottom: 0;
                padding-right: 0;
              "
              v-if="!selectedUploadLoading"
            >
              <div id="map" style="height: 350px">
                <MglMap
                  :accessToken="accessToken"
                  :mapStyle="mapStyle"
                  :center="[selectedUpload.longitude, selectedUpload.latitude]"
                  :zoom="15"
                  ref="mapboxmap"
                  style="width: 100%; height: 350px"
                >
                  <MglMarker
                    :coordinates="[
                      selectedUpload.longitude,
                      selectedUpload.latitude,
                    ]"
                    :color="markerColor"
                  />
                </MglMap>
              </div>
            </div>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-card md-theme-default">
            <div class="md-card-header">
              <h4 class="title" style ="display: inline !important">{{ $t("images.images") }}</h4>
              <md-button
                type="submit"
                class="md-primary"
                @click="showDialog = true"
                style="
                  background-color: #24e3c6 !important;
                  width: 50px;
                  border-radius: 50px;
                  float: right;
                  color: #181f33 !important;
                "
                ><md-icon class="md-size-2x" style="color: #181f33 !important;">add</md-icon></md-button
              >
            </div>
            <div class="md-content" style="padding: 20px" v-if="imagesLoading">
              <md-progress-spinner
                md-mode="indeterminate"
              ></md-progress-spinner>
            </div>
            <div
              class="md-card-content"
              style="
                width: 100%;
                padding-top: 15px;
                padding-left: 0;
                padding-bottom: 0;
                padding-right: 0;
              "
              v-if="!imagesLoading"
            >
              <lingallery
                :iid.sync="currentId"
                :items="images"
                :responsive="responsive"
                :showThumbnails="showThumbnails"
                v-if="images.length > 0"
              />
              <div class="alert alert-info" v-if="images.length == 0">
                <span><b> Info - </b> {{ $t("images.nan") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <div class="md-card md-theme-default">
          <div class="md-card-header">
            <span class="custom-span">
              <h4 class="title">{{ $t("add_info.title2") }}</h4>
            </span>
          </div>
          <div
            class="md-content"
            style="padding: 20px"
            v-if="selectedUploadLoading"
          >
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
          </div>
          <div
            class="md-content"
            style="padding: 20px"
            v-if="!selectedUploadLoading"
          >
            <h5>{{ $t("add_info.title") }} {{ selectedUpload.id }}</h5>
            <h5>
              {{ $t("add_info.date") }}: {{ selectedUpload.inspection_date }}
              <br />
              {{ $t("add_info.last_edit") }}:
              {{ selectedUpload.edit_date.toString() }}
            </h5>

            <form @submit.prevent="save_information">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="Tag">{{ $t("add_info.form.tag") }}</label>
                    <md-input
                      name="Tag"
                      id="tag"
                      v-model="selectedUpload.tag"
                      required
                  /></md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="medium">{{ $t("add_info.form.medium") }}</label>
                    <md-select
                      v-model="selectedUpload.medium"
                      name="medium"
                      id="medium"
                      required
                    >
                      <md-option value="drinking-water"
                        >{{ $t("add_info.form.treated") }}water</md-option
                      >
                      <md-option value="non-drinking-water"
                        >{{ $t("add_info.form.untreated") }}water</md-option
                      >
                      <md-option value="waste-water"
                        >{{ $t("add_info.form.waste") }}water</md-option
                      >
                    </md-select>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="coating">{{
                      $t("add_info.form.coating")
                    }}</label>
                    <md-select
                      v-model="selectedUpload.coating"
                      name="coating"
                      id="coating"
                      required
                    >
                      <md-option value="none"
                        >{{ $t("add_info.form.coatings.none") }}
                      </md-option>
                      <md-option value="bitumen">{{
                        $t("add_info.form.coatings.bitumen")
                      }}</md-option>
                      <md-option value="eppol">{{
                        $t("add_info.form.coatings.epoxy")
                      }}</md-option>
                      <md-option value="pe">{{
                        $t("add_info.form.coatings.pe")
                      }}</md-option>
                      <md-option value="zinc">{{
                        $t("add_info.form.coatings.zinc")
                      }}</md-option>
                      <md-option value="yes">
                        {{ $t("add_info.form.coatings.yes") }}
                      </md-option>
                      <md-option value="no">
                        {{ $t("add_info.form.coatings.no") }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="client_ref">{{
                      $t("add_info.form.clientRef")
                    }}</label>

                    <md-input
                      id="client_ref"
                      name="client_ref"
                      v-model="selectedUpload.client_ref"
                  /></md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="constructionyear">{{
                      $t("add_info.form.construction_year")
                    }}</label>
                    <md-input
                      type="number"
                      id="constructionyear"
                      name="constructionyear"
                      v-model="selectedUpload.constructionyear"
                      required
                  /></md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="wte"
                      >{{ $t("add_info.form.exp_wt") }} ({{
                        length1.view
                      }})</label
                    >
                    <md-input
                      id="wte"
                      name="wte"
                      v-model="selectedUpload.wallthickness_expected"
                      required
                  /></md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="diameter"
                      >{{ $t("add_info.form.diameter") }} (GIS,
                      {{ length1.view }})</label
                    >
                    <md-input
                      id="diameter"
                      name="diameter"
                      v-model="selectedUpload.diameter"
                      required
                  /></md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="circumference"
                      >{{ $t("add_info.form.circumference") }} ({{
                        length1.view
                      }})</label
                    >
                    <md-input
                      type="number"
                      id="circumference"
                      name="circumference"
                      v-model="selectedUpload.circumference"
                      :disabled="noEditing"
                      required
                  /></md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="wtev"
                      >{{ $t("add_info.form.val_wt") }} ({{
                        length1.view
                      }})</label
                    >
                    <md-input
                      type="number"
                      id="wtev"
                      name="wtev"
                      v-model="selectedUpload.wallthickness_expected_validation"
                      :disabled="noEditing"
                      required
                  /></md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="coverage"
                      >{{ $t("add_info.form.coverage") }} ({{
                        length2.view
                      }})</label
                    >
                    <md-input
                      type="number"
                      id="coverage"
                      name="coverage"
                      v-model="selectedUpload.coverage"
                      :disabled="noEditing"
                      required
                  /></md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="material">{{
                      $t("add_info.form.material")
                    }}</label>
                    <md-select
                      v-model="selectedUpload.material"
                      name="material"
                      id="material"
                      required
                      :disabled="noEditing"
                    >
                      <md-option value="AC">AC</md-option>
                      <md-option value="GGIJ">GGIJ </md-option>
                      <md-option value="PVC">PVC</md-option>
                      <md-option value="NGIJ">NGIJ</md-option>
                      <md-option value="STL">STL</md-option>
                      <md-option value="HDPE">HDPE</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="reason">{{ $t("add_info.form.reason") }}</label>
                    <md-select
                      v-model="selectedUpload.reason"
                      name="reason"
                      id="reason"
                      required
                    >
                      <md-option value="newproject">{{
                        $t("add_info.newProject")
                      }}</md-option>
                      <md-option value="failure"
                        >{{ $t("add_info.failure") }}
                      </md-option>
                      <md-option value="eol">{{
                        $t("add_info.eol")
                      }}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ $t("add_info.form.address") }}</label>
                    <md-autocomplete
                      v-model="selectedUpload.address"
                      :md-options="suggestions"
                      :md-open-on-focus="false"
                      @md-changed="update_suggestions"
                    ></md-autocomplete>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>{{ $t("add_info.form.comments") }}</label>
                    <md-textarea
                      v-model="selectedUpload.comments"
                    ></md-textarea>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-button type="submit" class="md-primary">{{
                    $t("add_info.form.btn")
                  }}</md-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <md-snackbar
      md-position="center"
      :md-duration="duration"
      :md-active.sync="showSnackbar"
      md-persistent
      v-if="!selectedUploadLoading"
    >
      <span>{{ $t("add_info.form.message") }} {{ selectedUpload.uuid }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";
import { MglMap, MglMarker } from "vue-mapbox";
import Lingallery from "lingallery";
import proj4 from "proj4";

import convert from "convert-units";
require("mapbox-gl/src/css/mapbox-gl.css");

//file list conversion to array
const fileListToArray = (fileList) => Array.from(fileList);

export default {
  name: "AddInfoPage",
  components: {
    MglMap,
    MglMarker,
    Lingallery,
  },
  created() {},
  data() {
    return {
      selectedImages: null,
      showDialog: false,
      convertLength: [
        "diameter",
        "wallthickness_expected",
        "wallthickness_expected_validation",
        "circumference",
      ],
      files: null,
      convertLength2: ["coverage"],
      orgUpload: null,
      suggestions: [],
      suggestion_coords: [],
      duration: 5000,
      selectedUpload: null,
      accessToken:
        "pk.eyJ1Ijoid2VybmVyYWNxIiwiYSI6ImNqeTc1d3VrajAxazUzb255NmM5cjhuMTYifQ.Z8ZqYDJDMAuGKKCHdehiSQ", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/mapbox/navigation-guidance-day-v4", // your map style
      centerCoordinates: [5.7918548, 53.2005936],
      colors: ["#ffa600", "#003157"],
      attentionUplaods: [],
      markerColor: "#003157",
      editFields: [
        "tag",
        "constructionyear",
        "diameter",
        "wallthickness_expected",
        "wallthickness_expected_validation",
      ],
      showSnackbar: false,
      colorSpec: {},
      imagesLoading: true,
      images: [],
      currentId: null,
      width: 600,
      height: 400,
      showThumbnails: false,
      responsive: true,
      map: null,
      markersReady: false,
      selectedUploadLoading: true,
    };
  },
  async mounted() {
    if (
      !this.groupServices.includes("pipescanner-inspections") ||
      !this.permissions.includes("edit:upload")
    ) {
      this.$router.push("/");
    } else {
      if (this.editPage.selectedInspection) {
        this.get_images();
        this.selectedUploadId = this.editPage.selectedInspection;
        //console.log(this.selectedUploadId);
        var query = {
          query:
            "SELECT * FROM c WHERE c.id IN ('" + this.selectedUploadId + "')",
        };
        var token = await this.$auth.getTokenSilently();
        var header = {
          headers: {
            Authorization: "Bearer " + token,
          },
        };
        var endpoint =
          this.apiEndpoints.base + this.apiEndpoints.pipescanner.custom;

        axios
          .post(endpoint, query, header)
          .then((response) => {
            //console.log(response.data);
            this.selectedUpload =
              response.data[this.groupSelected + "-pipescanner-inspections"][0];

            //console.log(this.selectedUpload);
            this.orgUpload = {
              ...response.data[
                this.groupSelected + "-pipescanner-inspections"
              ][0],
            };
            var inspProps = Object.keys(this.selectedUpload);
            if (!inspProps.includes("medium")) {
              if (
                this.groupSelected == "brabantwater.nl" ||
                this.groupSelected == "wml.nl"
              ) {
                this.selectedUpload["medium"] = "drinking-water";
              } else if (this.groupSelected == "hhnk.nl") {
                this.selectedUpload["medium"] = "waste-water";
              }
            }

            if (!inspProps.includes("tag")) {
              this.selectedUpload["tag"] = null;
            }
            if (!inspProps.includes("constructionyear")) {
              this.selectedUpload["constructionyear"] = null;
            }
            if (!inspProps.includes("wallthickness_expected")) {
              this.selectedUpload["wallthickness_expected"] = null;
            }

            this.selectedUpload["edit_date"] = new Date(
              this.selectedUpload._ts * 1000
            );
            console.log(this.selectedUpload.edit_date);

            this.selectedUpload["wallthickness_expected_validation"] = (
              this.selectedUpload.circumference / Math.PI / 2 -
              this.selectedUpload.diameter / 2
            ).toFixed(2);

            this.convert_units_view("save", "view");

            this.selectedUploadLoading = false;
          })
          .catch((error) => {
            this.$notify({
              message: "Error loading inspection data",
              icon: "check",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger",
            });
            this.$router.push("/");
          });
      } else {
        this.$router.push("/");
      }
    }
  },
  computed: {
    ...mapState([
      "groupServices",
      "editPage",
      "apiEndpoints",
      "groupSelected",
      "permissions",
      "units",
      "unitsDescription",
    ]),
    /**
     * computed property to disable editing for specific fields
     * @return {boolean} alway true.
     */
    noEditing() {
      return true;
    },
    /**
     * computed property for unit conversion between mm and in
     * @return {obj} object with both view and save units
     */
    length1() {
      return {
        view: this.unitsDescription[this.units].length,
        save: this.unitsDescription.metric.length,
        metric: this.unitsDescription.metric.length,
        imperial: this.unitsDescription.imperial.length,
      };
    },
    /**
     * computed property for unit conversion between m and ft
     * @return {obj} object with both view and save units
     */
    length2() {
      return {
        view: this.unitsDescription[this.units].length2,
        save: this.unitsDescription.metric.length2,
        metric: this.unitsDescription.metric.length2,
        imperial: this.unitsDescription.imperial.length2,
      };
    },
  },
  watch: {
    /**
     * watcher to check the validity of route compared to services of group
     * @param {Array} newVal - New value of group services
     */
    groupServices(newVal) {
      if (!newVal.includes("pipescanner-inspections")) {
        this.$router.push("/");
      }
    },
    /**
     * watcher to convert units
     * @param {String} newVal, oldVal - New and old value for selected units
     */
    units(newVal, oldVal) {
      this.convert_units_view(oldVal, newVal);
    },
  },
  methods: {
    /**
     * watcher to check the validity of route compared to services of group
     * @param {fileList} files - selected files of images
     */
    select_files(files) {
      this.files = files;
    },
    /**
     * function to post images to api
     */
    async save_images() {
      var filesArray = fileListToArray(this.files);

      var data = new FormData();
      filesArray.forEach(file => {
        data.append("upload_file", file);
      })
      
      var url =
        this.apiEndpoints.base +
        this.apiEndpoints.pipescanner.add_images +
        this.selectedUpload.id +
        "/" +
        this.groupSelected;
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      };
      axios
        .post(url, data, header)
        .then((response) => {
          //console.log(response)
          this.$notify({
            message: "Images save",
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
          this.showDialog = false;
          this.selectedImages = null;
          this.get_images();
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * function to convert units from
     * @param {str} source - current units
     * @param {str} target - target units
     */
    convert_units_view(source, target) {
      this.convertLength.forEach((key) => {
        if (this.selectedUpload[key]) {
          this.selectedUpload[key] = parseFloat(
            this.convert(parseFloat(this.selectedUpload[key]))
              .from(this.length1[source])
              .to(this.length1[target])
              .toFixed(3)
          );
        }
      });
      this.convertLength2.forEach((key) => {
        if (this.selectedUpload[key]) {
          this.selectedUpload[key] = parseFloat(
            this.convert(parseFloat(this.selectedUpload[key]))
              .from(this.length2[source])
              .to(this.length2[target])
              .toFixed(3)
          );
        }
      });
    },
    /**
     * function to fetch images for inspection from api
     */
    async get_images() {
      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base +
        this.apiEndpoints.pipescanner.images +
        this.editPage.selectedInspection +
        "/" +
        this.groupSelected;

      axios
        .get(endpoint, header)
        .then((response) => {
          this.images = response.data.map((x) => {
            return { id: x.fileName, src: x.image };
          });

          this.imagesLoading = false;
        })
        .catch((error) => {
          if (error) {
            this.$notify({
              message: error,
              icon: "check",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger",
            });
          }
        });
    },
    /**
     * function to fetch suggestions for address from mapbox api
     * @param {string} value - address as string
     */
    update_suggestions(value) {
      var str = value;
      var search_txt = encodeURIComponent(str.trim());

      var acc_token =
        "pk.eyJ1Ijoid2VybmVyYWNxIiwiYSI6ImNqeTc1d3VrajAxazUzb255NmM5cjhuMTYifQ.Z8ZqYDJDMAuGKKCHdehiSQ";
      var url =
        "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
        search_txt +
        ".json?access_token=" +
        acc_token +
        "&country=NL&autocomplete=true";
      if (str != "") {
        axios
          .get(url)
          .then((result) => {
            if (result.data.features.length > 0) {
              var features = result.data.features;

              var mappedfeatures = features.map((x) => x.place_name);
              var mappedcoords = features.map((x) => x.center);
              this.suggestion_coords = mappedcoords;
              this.suggestions = mappedfeatures;
              //return this.suggestions;
              //result.data.features[0].center
              //console.log(this.suggestions);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    /**
     * function to save diffs in inspection info!
     */
    async save_information() {
      var diffs = this.difference(this.selectedUpload, this.orgUpload);
      var keys = Object.keys(diffs);
      if (keys.includes("wallthickness_expected")) {
        diffs.wallthickness_expected = parseFloat(
          this.convert(parseFloat(diffs.wallthickness_expected))
            .from(this.length1.view)
            .to(this.length1.save)
        );
      }
      if (keys.includes("wallthickness_expected_validation")) {
        diffs.wallthickness_expected_validation = parseFloat(
          this.convert(parseFloat(diffs.wallthickness_expected_validation))
            .from(this.length1.view)
            .to(this.length1.save)
        );
      }

      if (keys.includes("circumference")) {
        diffs.circumference = parseFloat(
          this.convert(parseFloat(diffs.circumference))
            .from(this.length1.view)
            .to(this.length1.save)
        );
      }

      if (keys.includes("diameter")) {
        diffs.diameter = parseInt(
          this.convert(parseFloat(diffs.diameter))
            .from(this.length1.view)
            .to(this.length1.save)
        );
      }

      if (keys.includes("constructionyear")) {
        diffs.constructionyear = parseInt(diffs.constructionyear);
      }
      console.log(diffs);

      var token = await this.$auth.getTokenSilently();
      var header = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      var endpoint =
        this.apiEndpoints.base +
        this.apiEndpoints.pipescanner.edit +
        this.selectedUpload.id +
        "/" +
        this.groupSelected;
      axios
        .post(endpoint, diffs, header)
        .then((response) => {
          //console.log(response)
          this.$notify({
            message: "Edit complete",
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            message: error,
            icon: "check",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    /**
     * mapped function
     */
    convert: convert,
    /**
     * function to isolate the difference between two object.
     * @param {obj} object - latest version of the object
     * @param {obj} base - base object you want to compare with
     * @return {obj} object with the differences between object and base.
     */
    difference(object, base) {
      return this._.transform(object, (result, value, key) => {
        if (!this._.isEqual(value, base[key])) {
          result[key] =
            this._.isObject(value) && this._.isObject(base[key])
              ? this.difference(value, base[key])
              : value;
        }
      });
    },
  },
};
</script>
